import { generateColorScheme } from './../../src/utils/colors';

export const secondary = generateColorScheme('#00D3C3');
